/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type BioExamResult from "parog-web/models/bio-exam-result";

import fileAttachmentsCellStyles from "../file-attachments-cell/index.module.css";

import styles from "./index.module.css";

interface Signature {
  Args: {
    originJournalEvent?: unknown;
    result: BioExamResult;
  };
}

export default class BioExamResultsSummaryRowCellComponent extends Component<Signature> {
  styles = styles;

  fileAttachmentsCellStyles = fileAttachmentsCellStyles;

  get minValue() {
    return this.args.result.resultHash.normValInf;
  }

  get maxValue() {
    return this.args.result.resultHash.normValSupp;
  }

  get shouldDisplayReferences() {
    return this.minValue || this.maxValue;
  }

  get tooltipText() {
    if (!this.minValue && this.maxValue) {
      return "Références : [ - : ".concat(this.maxValue, "]");
    } else if (this.minValue && !this.maxValue) {
      return "Références : [".concat(this.minValue, " : - ]");
    }

    return "Références : [".concat(
      this.minValue as string,
      " : ",
      this.maxValue as string,
      "]"
    );
  }
}
